<template>
    <div class=" py-12 px-6 text-center">
      <h1 class="text-3xl font-bold text-gray-900 mb-2">INTEGRATOR CONTROL PANEL</h1>
      <p class="text-sm text-gray-500 mb-6">Publique seus aplicativos em VPS com simplicidade</p>
      <p class="text-gray-600 max-w-3xl mx-auto mb-6">
        Utilize nosso sistema para manipular containers Docker com toda a liberdade que existe para um administrador, contando com a simplicidade de modelos pré-criados para tornar mais rápida sua publicação na Internet.
      </p>
      <div class="flex flex-col sm:flex-row justify-center gap-4 mb-10">
        <a href="/plano-vps-icp" class="bg-[#f94368] text-white font-semibold py-3 px-6 rounded-full shadow hover:bg-[#e13358] transition">
          OPORTUNIDADE DE LANÇAMENTO, COMPRE AGORA
        </a>
        <a href="https://demo.icontainer.run:2087/demo" target="_blank" class="bg-blue-600 text-white font-semibold py-3 px-6 rounded-full shadow hover:bg-blue-500 transition">
          VEJA O PAINEL FUNCIONAL: ACESSE O DEMONSTRATIVO
        </a>
      </div>
  
      <div v-for="(item, index) in demos" :key="index" class="mb-12">
        <div class="bg-white shadow-md rounded-lg overflow-hidden max-w-6xl mx-auto">
            <img :src="item.imagem" :alt="item.alt" class="w-full" />
        </div>

        <div class="mt-8 text-gray-700 max-w-2xl mx-auto">
            <h2 class="text-xl font-semibold mb-2">{{ item.titulo }}</h2>
            <p>{{ item.descricao }}</p>
        </div>
      </div>

    </div>
  </template>
  
  <script setup>
const demos = [
  {
    imagem: '/painel-icp-prints/ic-app-store.jpg',
    alt: 'Demo ICP',
    titulo: 'App Store',
    descricao:
      'Aplicativos e tecnologias populares em Containers para uso imediato, pré-configurados. Com a App Store, você seleciona e instala sem precisar entender de Container, Linux ou de como configurar o aplicativo.'
  },
  {
    imagem: '/painel-icp-prints/ic-dominio-standalone.jpg',
    alt: 'Domínio e SSL',
    titulo: 'Domínio e SSL',
    descricao:
      'Com poucos cliques você pode colocar domínios e configurar SSL apontando para aplicativos que instalou. O painel permite colocar SSL gratuíto como o Lets Encrypt, ou até mesmo configurar certificados pagos.'
  },
  {
    imagem: '/painel-icp-prints/ic-dominio-db.jpg',
    alt: 'Banco de dados',
    titulo: 'Banco de dados',
    descricao:
      'Gerencie bancos de dados como MySQL, PostgreSQL e etc, usando nossos assistentes. Instale várias versões de um servidor de banco de dados, configure usuários, dê permissões e tenha acesso acesso remoto sem fazer qualquer esforço.'
  },
  {
    imagem: '/painel-icp-prints/ic-dominio-db.jpg',
    alt: 'Logs',
    titulo: 'Logs',
    descricao:
      'O painel conta com logs completos para maior controle e segurança: logs de acesso, operações realizadas, tentativas de login, e eventos do sistema. Monitore todas as atividades de forma prática e detalhada.'
  },
  {
    imagem: '/painel-icp-prints/ic-monitor.jpg',
    alt: 'Monitoramento de Recursos',
    titulo: 'Monitoramento de Recursos',
    descricao:
      'O painel oferece monitoramento completo de recursos com gráficos detalhados: acompanhe a carga média, uso de CPU, memória, disco I/O e rede I/O em tempo real, garantindo total controle do sistema.'
  },
  {
    imagem: '/painel-icp-prints/ic-firewall.jpg',
    alt: 'Firewall',
    titulo: 'Firewall',
    descricao:
      'O painel disponibiliza um firewall avançado com controle total, permitindo o bloqueio de portas indesejadas e a criação de regras personalizadas. Administre a segurança da sua rede de forma eficiente, protegendo seus dados contra acessos não autorizados e ameaças externas.'
  },
  {
    imagem: '/painel-icp-prints/ic-fail2ban.jpg',
    alt: 'Fail2ban',
    titulo: 'Fail2ban',
    descricao:
      'Proteja seu sistema com o Fail2Ban integrado: detecta e bloqueia tentativas suspeitas de acesso, garantindo segurança contra ataques de força bruta e outras ameaças de forma eficiente e automatizada.'
  }
]





  </script>
  
  <style scoped>
  </style>